// uploadMessagePhoto — client-side resize + Firebase Storage upload for
// an optional photo attached to a worker -> learner message (Stage 9).
//
// Storage path is keyed by messageId so the photo is removed alongside
// the doc when a worker retracts:
//   messages-photos/{messageId}.jpg
//
// Stage 10: resize logic extracted to resizeImageToBlob shared util.

import { getFirebase } from "@goodbye/firebase";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { resizeImageToBlob } from "./resizeImageToBlob";

export interface UploadMessagePhotoInput {
  messageId: string;
  file: File;
}

export interface UploadMessagePhotoResult {
  photoUrl: string;
  photoStoragePath: string;
}

export async function uploadMessagePhoto(
  input: UploadMessagePhotoInput,
): Promise<UploadMessagePhotoResult> {
  const { messageId, file } = input;
  const blob = await resizeImageToBlob(file);
  const storage = getFirebase().storage;
  const path = `messages-photos/${messageId}.jpg`;
  const storageRef = ref(storage, path);
  await uploadBytes(storageRef, blob, { contentType: "image/jpeg" });
  const photoUrl = await getDownloadURL(storageRef);
  return { photoUrl, photoStoragePath: path };
}
